import type { MaintenancePeriod } from '@common/models/config/system.modl'
import logoImage from '@assets/images/logo_L.png'

function formatPeriod(period: MaintenancePeriod): string {
  const start = period.startDate.toLocaleString('ja-JP', {
    dateStyle: 'long',
    timeStyle: 'short',
  })
  const end = period.endDate.toLocaleString('ja-JP', {
    dateStyle: 'long',
    timeStyle: 'short',
  })
  return `${start} ～ ${end}`
}

type MaintenanceScreenProps = {
  activeMaintenancePeriod: MaintenancePeriod | null
}

function MaintenanceScreen({ activeMaintenancePeriod }: MaintenanceScreenProps) {
  return (
    <div className="error-container">
      <img src={logoImage} alt="IROGAMI" className="error-page__logo" />
      <div className="error-card">
      <h1 className="error-code maintenance-code mb-4">メンテナンス</h1>
        <p className="error-message">
          只今、システムメンテナンスを実施しております。
        </p>
        <p className="error-description">
          {activeMaintenancePeriod
            ? formatPeriod(activeMaintenancePeriod)
            : 'しばらく時間をおいてから再度お試しください。'}
        </p>
        <div className="error-actions">
          <button
            onClick={() => window.location.reload()}
            className="error-button error-button-primary"
          >
            再読み込み
          </button>
        </div>
      </div>
    </div>
  )
}

export default MaintenanceScreen
